import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class AppService {
  private _bgClass = new Subject<string>();
  private _showLoader = new Subject<boolean>();
  private _showMainNav = new Subject<boolean>();
  private _showPrintSelection = new Subject<boolean>();
  private _monthlyKeys: string[] = [];
  private _printers: string[] = ['Accounting Printer', 'Shop Printer'];
  private _invSelectedPrinter = new Subject<string>();
  private _printItem:any;
  private _printFor:string;

  bgClass$ = this._bgClass.asObservable();
  showLoader$ = this._showLoader.asObservable();
  showMainNav$ = this._showMainNav.asObservable();
  invSelectedPrinter$ = this._invSelectedPrinter.asObservable();
  showPrintSelection$ = this._showPrintSelection.asObservable();

  constructor() {
    this._monthlyKeys.push('Evaluator');
    this._monthlyKeys.push('Subject');
    for(let i = 1; i <= 60; i++)
    {
      let k = 'Q'+i;
      if([1, 8, 18, 37, 49, 57, 60].indexOf(i) !== -1) {
        k = k+'*';
      }
      this._monthlyKeys.push(k);
    }
    this._monthlyKeys.push('Avg');

   }

   getPrinters(): string[] {
    return this._printers;
   }

   setInvPrinter(p:string) {
    this._invSelectedPrinter.next(p);
    this.hidePrintSelection();
   }

   getPrintItem():any {
    return this._printItem;
   }

   setPrintItem(i:any) {
    this._printItem = i;
   }

   getMonthlyKeys(): string[] {
    return this._monthlyKeys;
   }

  setbgClass(styleText: string): void {
    this._bgClass.next(styleText);
  }

  hideLoader():void {
    this._showLoader.next(false);
  }

  showLoader():void {
    this._showLoader.next(true);
  }

  hideNav(): void {
    this._showMainNav.next(false);
  }

  showPrintSelection(which:string): void {
    this._printFor = which;
    this._showPrintSelection.next(true);
  }

  hidePrintSelection(): void {
    this._showPrintSelection.next(false);
  }

  getPrintFor():string {
    return this._printFor;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/app.service.ts